/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useEffect } from "react";
import NAV from "./nav";
import Carousel from "./carousel";

const FundDetailsStandalone = () => {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.tailwindcss.com?plugins=forms,container-queries";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.tailwind.config = {
        darkMode: "class",
        theme: {
          extend: {
            colors: {
              "surface-container": "#edeeef",
              "primary-container": "#28a745",
              "surface-container-low": "#f3f4f5",
              "primary": "#006e25",
              "on-surface": "#191c1d",
              "on-surface-variant": "#3e4a3c",
              "surface-container-high": "#e7e8e9",
              "surface": "#f8f9fa",
              "secondary": "#346669",
              "outline": "#6e7b6b",
              "error": "#ba1a1a",
            },
            fontFamily: {
              headline: ["Manrope"],
              body: ["Inter"],
              label: ["Inter"]
            }
          }
        }
      };
    };

    const fonts = document.createElement("link");
    fonts.href =
      "https://fonts.googleapis.com/css2?family=Manrope:wght@400;700;800&family=Inter:wght@300;400;500;600&display=swap";
    fonts.rel = "stylesheet";
    document.head.appendChild(fonts);

    const icons = document.createElement("link");
    icons.href =
      "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";
    icons.rel = "stylesheet";
    document.head.appendChild(icons);

    const style = document.createElement("style");
    style.innerHTML = `
      .glass-nav { backdrop-filter: blur(20px); }
      .custom-scrollbar::-webkit-scrollbar { width:4px }
      .custom-scrollbar::-webkit-scrollbar-thumb { background:#bdcab9 }
    `;
    document.head.appendChild(style);

  }, []);

  return (
    <div className="bg-surface text-on-surface font-body">
          <div className="container-fluid position-relative p-0">
        <NAV activetag="mf"/>
        <Carousel activetag="mf"/>
        {/*<!-- Header Start -->*/}
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5" style={{maxwidth: '500px'}}>
            <h4 className="text-white display-4 mb-4 wow fadeInDown"
                data-wow-delay="0.1s">Mutual Funds</h4>

          </div>
        </div>
      </div>


      {/* HERO */}
      <main className="max-w-screen-2xl mx-auto px-6 py-8 flex flex-col gap-8">

        <section className="flex flex-col md:flex-row justify-between gap-8">

          <div className="flex-1 space-y-4">

            <div className="flex items-center gap-2 text-primary font-bold uppercase text-xs">
              <span className="bg-primary-container/10 px-2 py-1 rounded">
                Equity: Large Cap
              </span>
              <span>• Growth Plan</span>
            </div>

            <h1 className="text-5xl font-extrabold">
              ICICI Prudential Bluechip Fund
            </h1>

            <p className="flex items-center gap-2 text-on-surface-variant">
              AMC: ICICI Prudential
              <span className="material-symbols-outlined text-primary">
                verified
              </span>
            </p>

            <div className="flex gap-8 pt-4">

              <div>
                <span className="text-sm text-on-surface-variant">
                  NAV
                </span>
                <div className="flex gap-2 items-baseline">
                  <span className="text-3xl font-bold">₹94.28</span>
                  <span className="text-primary">+1.24%</span>
                </div>
              </div>

              <div>
                <span className="text-sm text-on-surface-variant">
                  SIP
                </span>
                <div className="text-xl font-bold">₹100</div>
              </div>

              <div>
                <span className="text-sm text-on-surface-variant">
                  AUM
                </span>
                <div className="text-xl font-bold">₹48,291 Cr</div>
              </div>

            </div>

          </div>

          <div className="flex gap-3">
            <button className="bg-surface-container-high px-6 py-3 rounded-full">
              Start SIP
            </button>
            <button className="bg-primary text-white px-8 py-3 rounded-full">
              Invest Now
            </button>
          </div>

        </section>

        {/* GRID */}
        <div className="grid lg:grid-cols-12 gap-8">

          {/* CHART */}
          <div className="lg:col-span-8 bg-white p-6 rounded-3xl">

            <h2 className="font-bold mb-4">Performance Timeline</h2>

            <div className="h-[300px] bg-gray-100 rounded-xl flex items-end">
              <svg viewBox="0 0 1000 100" className="w-full h-full">
                <path
                  d="M0,80 Q100,75 200,60 T400,65 T600,40 T800,45 T1000,10"
                  fill="none"
                  stroke="green"
                  strokeWidth="3"
                />
              </svg>
            </div>

          </div>

          {/* ANALYTICS CARD */}
          <div className="lg:col-span-4 bg-primary text-white p-6 rounded-3xl">

            <h2 className="text-xl font-bold mb-4">
              Orion Intelligence
            </h2>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <div className="text-xs">Sharpe</div>
                <div className="text-2xl font-bold">1.82</div>
              </div>

              <div>
                <div className="text-xs">Alpha</div>
                <div className="text-2xl font-bold">4.2%</div>
              </div>

              <div>
                <div className="text-xs">Volatility</div>
                <div className="text-2xl font-bold">12.4%</div>
              </div>

              <div>
                <div className="text-xs">Beta</div>
                <div className="text-2xl font-bold">0.88</div>
              </div>
            </div>

          </div>

          {/* PORTFOLIO */}
          <div className="lg:col-span-7 bg-white p-6 rounded-3xl">

            <h2 className="font-bold mb-4">
              Portfolio Composition
            </h2>

            <div className="space-y-3">
              <div>Financial Services 32%</div>
              <div>IT 18%</div>
              <div>Energy 12%</div>
            </div>

          </div>

          {/* PEER TABLE */}
          <div className="lg:col-span-5 bg-white p-6 rounded-3xl">

            <h2 className="font-bold mb-4">
              Peer Comparison
            </h2>

            <table className="w-full">
              <thead>
                <tr>
                  <th>Fund</th>
                  <th>Return</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>ICICI Bluechip</td>
                  <td>18.2%</td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>

        {/* FOOTER */}
        <footer className="p-6 bg-gray-100 rounded-xl">
          Mutual fund investments are subject to market risks.
        </footer>

      </main>

    </div>
  );
};

export default FundDetailsStandalone;